import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessProcessInvokeListComponent } from './business-process-invoke-list/business-process-invoke-list.component';
import { CommonComponentsModule } from '../../common/common.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { QueueGridComponent } from './queue components/queue-grid/queue-grid.component';
import { QueueCardComponent } from './queue components/queue-card/queue-card.component';
import { QueueCardListComponent } from './queue components/queue-card-list/queue-card-list.component';
import {InteractionFilterModalComponent} from './interaction-filter-modal/interaction-filter-modal.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { CustomInteractionQueueComponent } from './custom-interaction-queue/custom-interaction-queue.component';
import {BusinessProcessSuspendedListComponent} from './business-process-suspended-list/business-process-suspended-list.component';
import {BusinessProcessInvokeFilterComponent} from './business-process-invoke-filter/business-process-invoke-filter.component';
import { TotalsPerAgreementsModalComponent } from './custom-interaction-queue/totals-per-agreements-modal/totals-per-agreements-modal.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { SequentialAllocationComponent } from './sequential-allocation/sequential-allocation.component';
import {ReviewInstancesComponent} from './review-instances/review-instances.component';
import {ReviewModalComponent} from './review-instances/review-modal/review-modal.component';



@NgModule({
    declarations: [
        BusinessProcessInvokeListComponent,
        QueueGridComponent,
        QueueCardComponent,
        QueueCardListComponent,
        InteractionFilterModalComponent,
        CustomInteractionQueueComponent,
        BusinessProcessSuspendedListComponent,
        BusinessProcessInvokeFilterComponent,
        TotalsPerAgreementsModalComponent,
        SequentialAllocationComponent,
        ReviewInstancesComponent,
      ReviewModalComponent
    ],
    entryComponents: [
        BusinessProcessInvokeListComponent,
        InteractionFilterModalComponent,
        CustomInteractionQueueComponent,
        BusinessProcessSuspendedListComponent,
        TotalsPerAgreementsModalComponent,
        SequentialAllocationComponent,
        ReviewInstancesComponent,
      ReviewModalComponent
    ],
  exports: [
    QueueCardComponent,
    QueueGridComponent
  ],
    imports: [
        CommonModule,
        CommonComponentsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        FormsModule,
        TabsModule.forRoot(),
    ]
})
export class HumanInteractionModule { }
